export const SURVEY_DISPLAY_ORDER_MIN = 0;
export const SURVEY_DISPLAY_ORDER_MAX = 10;
export const VIDEO_DISPLAY_ORDER_MIN = 0;
export const VIDEO_DISPLAY_ORDER_MAX = 10;

const DISPLAY_ORDER_RULES = {
  pattern: /^(10|[0-9])$/,
  min: 0,
  max: 10
};

function isDisplayOrderInvalid(displayOrder, {pattern, min, max}) {
  if (displayOrder === '' || displayOrder == null) {
    return true;
  }

  const raw = String(displayOrder).trim();
  if (!pattern.test(raw)) return true;

  const n = Number(raw);
  if (!Number.isInteger(n) || n < min) return true;
  if (max !== undefined && n > max) return true;

  return false;
}

export const isSurveyDisplayOrderInvalid = (displayOrder) =>
  isDisplayOrderInvalid(displayOrder, DISPLAY_ORDER_RULES);

export const isVideoDisplayOrderInvalid = (displayOrder) =>
  isDisplayOrderInvalid(displayOrder, DISPLAY_ORDER_RULES);

export function sanitizeDisplayOrderInput(value) {
  if (value === '' || value === null || value === undefined) {
    return '';
  }

  if (typeof value === 'number' && value < 0) {
    return '';
  }

  const str = String(value);
  if (str.trim().startsWith('-')) {
    return '';
  }

  const digits = str.replace(/[^0-9]/g, '');
  if (digits === '') {
    return '';
  }

  const num = Number(digits);
  if (num > DISPLAY_ORDER_RULES.max) {
    return DISPLAY_ORDER_RULES.max;
  }

  return num;
}

export function sanitizeNonNegativeIntegerInput(value) {
  if (value === '' || value === null || value === undefined) {
    return '';
  }

  if (typeof value === 'number' && value < 0) {
    return '';
  }

  const str = String(value);
  if (str.trim().startsWith('-')) {
    return '';
  }

  const digits = str.replace(/[^0-9]/g, '');
  if (digits === '') {
    return '';
  }

  return Number(digits);
}

export function blockDisplayOrderKeyDown(e) {
  if (['+', '.', 'e', 'E', '-', ','].includes(e.key)) {
    e.preventDefault();
  }
}

export function normalizeDisplayOrderForCounter(displayOrder, isInvalidFn) {
  if (displayOrder === '' || displayOrder == null) {
    return '';
  }
  if (isInvalidFn(displayOrder)) {
    const sanitized = sanitizeDisplayOrderInput(displayOrder);
    return sanitized === '' ? '' : sanitized;
  }
  return Number(String(displayOrder).trim());
}

export function parseValidDisplayOrder(displayOrder, isInvalidFn) {
  if (isInvalidFn(displayOrder)) return null;
  return Number(String(displayOrder).trim());
}
